module.exports = __webpack_public_path__ + "img/calendar-alt.c768c2cb.svg";